import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';
import { sumOfItemPrice } from '../ga4utils';

export function trackAddToCart({
  location,
  currency,
  addedItems,
}: {
  location: string;
  currency: string;
  addedItems: EcommerceCartItem | Array<EcommerceCartItem> | undefined;
}) {
  pushToDataLayer({
    event: 'add_to_cart',
    location: location,
    value: sumOfItemPrice(addedItems),
    ecommerce: {
      currency,
      items: Array.isArray(addedItems) ? addedItems : [addedItems],
    },
  });
}
